import { DictionaryValue } from '@sdbn/common-essential';


/** Transport Visualization DB Model **/

export class TransportColoringTheme {
  id: string | undefined;
  insertDate: string | undefined;
  updateDate: string | undefined;
  isDefault: boolean | undefined;
  name: string | undefined;
  transportColoringRule = new Array<TransportColoringRule>();
  constructor(value?: Partial<TransportColoringTheme>) {
    if (value != null) {
      this.id = value.id;
      this.insertDate = value.insertDate;
      this.updateDate = value.updateDate;
      this.isDefault = value.isDefault;
      this.name = value.name;
      if (value.transportColoringRule != null) {
        for (const item of value.transportColoringRule) {
          this.transportColoringRule.push(new TransportColoringRule(item));
        }
      }
    }
  }
}

export class TransportColoringRule {
  id: string | undefined;
  insertDate: string | undefined;
  updateDate: string | undefined;
  colorBackgroundDark: string | undefined;
  colorForegroundDark: string | undefined;
  colorBackgroundLight: string | undefined;
  index: number | undefined;
  name: string | undefined;
  iconCss: string | undefined;
  condition: string | undefined;
  colorForegroundLight: string | undefined;
  constructor(value?: Partial<TransportColoringRule>) {
    if (value != null) {
      this.id = value.id;
      this.insertDate = value.insertDate;
      this.updateDate = value.updateDate;
      this.colorBackgroundDark = value.colorBackgroundDark;
      this.colorForegroundDark = value.colorForegroundDark;
      this.colorBackgroundLight = value.colorBackgroundLight;
      this.index = value.index;
      this.name = value.name;
      this.iconCss = value.iconCss;
      this.condition = value.condition;
      this.colorForegroundLight = value.colorForegroundLight;
    }
  }
}



/** Transport Management DB Model **/

export class VehicleArchive {
  id: string | undefined;
  insertDate: string | undefined;
  updateDate: string | undefined;
  blocked: boolean | undefined;
  numberPlateNormalized: string | undefined;
  cabotageWhitelisted: boolean | undefined;
  note: string | undefined;
  whitelisted: boolean | undefined;
  numberplate: string | undefined;
  constructor(value?: Partial<VehicleArchive>) {
    if (value != null) {
      this.id = value.id;
      this.insertDate = value.insertDate;
      this.updateDate = value.updateDate;
      this.blocked = value.blocked;
      this.numberPlateNormalized = value.numberPlateNormalized;
      this.cabotageWhitelisted = value.cabotageWhitelisted;
      this.note = value.note;
      this.whitelisted = value.whitelisted;
      this.numberplate = value.numberplate;
    }
  }
}

